import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class SideDrawerService extends Service {
  @tracked isOpen = false;

  closeDrawer = () => {
    this.isOpen = false;
  };

  toggleDrawer = () => {
    this.isOpen = !this.isOpen;
  };
}
